// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1wAad","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__Th2nN"};